// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__20Pvy","list":"styles_list__xsTK9"};